<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Form" });
import "tailwindcss/tailwind.css";
import { onMount } from "svelte";
import { addMessage } from "../../stores/messages.js";
import { trackFormConversion, scanForForms } from "../../common/analytics.js";
export let error = "";
export let id = "";
export let align = "vertical";
export let css = "";
export let onSubmit = async () => {
};
export let isSubmittedOnEnter = true;
const NAME = `s8-form-${id}`;
let isLoading = false;
let form = null;
const executeRequest = async () => {
    isLoading = true;
    error = "";
    await onSubmit();
    trackFormConversion(NAME);
    isLoading = false;
};
const checkInputValidity = (element) => {
    if (!element.validity.valid) {
        element.dispatchEvent(new Event("invalid"));
    }
    return element.validity.valid;
};
const checkCustomValidity = (element) => {
    element.dispatchEvent(new Event("invalid"));
    return element.validity.valid;
};
export const isValid = () => {
    const VALIDITY = [];
    if (form === null) {
        return true;
    }
    for (const ELEMENT of form) {
        VALIDITY.push(checkInputValidity(ELEMENT));
    }
    for (const ELEMENT of form.querySelectorAll("input[data-custom-validation]")) {
        VALIDITY.push(checkCustomValidity(ELEMENT));
    }
    return !VALIDITY.includes(false);
};
const validateThenSubmit = async () => {
    if (isLoading) {
        return;
    }
    if (isValid()) {
        await executeRequest();
        return;
    }
    if (window.innerWidth > 1020) {
        addMessage({
            description: "global.validation.form.description",
            heading: "global.validation.form.heading",
            type: "warning"
        });
    }
};
onMount(() => {
    if (form === null) {
        return;
    }
    scanForForms(form.parentElement);
});
const handleKeypress = (event) => {
    if (event.key === "Enter" && !isSubmittedOnEnter) {
        event.preventDefault();
    }
};
export const submit = async () => {
    await validateThenSubmit();
};
export const reset = () => {
    if (form === null) {
        return;
    }
    form.reset();
};
</script>

<form
    bind:this = { form }
    novalidate
    autocomplete = 'on'
    class = { `s8-form s8-form-${ align } ${ css }` }
    id = { NAME }
    name = { NAME }
    class:s8-is-loading = { isLoading }
    on:submit|preventDefault = { validateThenSubmit }
    on:keypress = { handleKeypress }>

    <div class = 's8-form-body'>
        <slot>Hello World</slot>
    </div>

    {#if 'footer' in $$slots }
        <div class = 's8-form-footer'>
            <slot name = 'footer' />
        </div>
    {/if}

</form>

<style>

    form.s8-form:not(.s8-form-skeleton) {
            width: 100%;
        }

        form.s8-form.s8-form-horizontal {
            display: flex;
            -moz-column-gap: 10px;
                 column-gap: 10px;
            align-items: top;
        }

        form.s8-form.s8-form-horizontal div.s8-form-footer {
                display: flex;
                flex: 0 0 auto;
            }

        form.s8-form.s8-form-horizontal div.s8-form-footer :global(> button) {
                    display: block;
                }

        form.s8-form.s8-form-horizontal div.s8-form-body {
                flex: 1 1 auto;
                -moz-column-gap: 10px;
                     column-gap: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

        form.s8-form.s8-form-horizontal div.s8-form-body :global(>div.s8-form-row) {
                    flex: 1 1 auto;
                }</style>